<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="isDeletePage() != true ? 'User Addresses' : 'Deleted User Addresses'"
              ></h3>
              <!-- <template v-if="isDeletePage() != true">
                  <v-btn
                    class="mx-2 mb-2"
                    fab
                    x-small
                    color="primary"
                    to="/offers/create"
                  >
                    <v-icon dark> mdi-plus </v-icon>
                  </v-btn>
                </template> -->
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    clearable
                    @click:clear="(filter.is_active = null), (page = 1)"
                    label="Status"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="285"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-start sr_no">Sr No</th>
                      <th class="text-start">Status</th>
                      <th class="text-start">User Id</th>
                      <th class="text-start">Adress</th>
                      <th class="text-start action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="user_addresses.length != 0">
                    <tr
                      v-for="(address, i) in user_addresses"
                      :key="`address_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': address.length - 1 == i,
                      }"
                    >
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="address.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>address is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="address.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>address is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>
                        {{ address.user ? address.user.first_name : "N/A" }}
                      </td>

                      <td>
                        {{
                          address.address_line1 + ',' + address.address_line2 || "N/A"
                        }}
                      </td>
                      <td>
                        <template v-if="!isDeletePage()">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Delete_this(address.id)"
                              >
                                <v-icon dark>mdi-delete</v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this address </span>
                          </v-tooltip>
                          <!-- <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/address/${encryptIt(offer.id)}`"
                              >
                                <v-icon dark>mdi-pencil</v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this offer</span>
                          </v-tooltip> -->
                        </template>
                      </td>

                      <!-- <td>
                          {{ offer.status == 1 ? "APPROVED" : "PENDING" }}
                        </td> -->

                      <td class="text-right"></td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="7" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_address" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>address deleted successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_deleted_address = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_address" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Notification restored successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_restored_address = false"
                      >
                        OK
                      </v-btn>
                    </v-col>

                    <v-col sm="9" align="center">
                      <v-card-text>
                        <v-row>
                          <v-col>
                            <h1 style="color: green">Hurray!</h1>
                            <br />
                            <h3>offer deleted successfully.</h3>
                            <br />
                            <v-btn
                              color="success"
                              @click="is_deleted_address = false"
                            >
                              OK
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "AdressesPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
        rowsPerPage: 10, // Default to 10 rows per page
      },

      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,

      user_addresses: [],
      is_restored_address: false,
      isLoading: false,
      isExcelloading: false,
      delete_offer: false,
      is_deleted_address: false,
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&is_active=" +
        this.filter.is_active +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`user_addresses?${query}`)
        .then((response) => {
          this.user_addresses = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },

    // async Delete_this(id) {
    //   await axios
    //     .post(`/user_addresses/delete/${this.encryptIt(id)}`)
    //     .then(() => {
    //       this.delete_address = false;
    //       this.is_deleted_address = true;
    //       this.getData();
    //     })

    //     this.delete_address = true;

    // },
    // async Delete_this(id) {
    //   await axios
    //     .post(`/user_addresses/delete/${this.encryptIt(id)}`)
    //     .then(() => {
    //       this.getData();
    //     })
    //     .catch((error) => {
    //       console.error(error);
    //     });
    // },
    async Delete_this(id) {
      this.delete_address = true;
      await axios
        .post(`/user_addresses/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_address = false;
          this.is_deleted_address = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          //   findwindow.location.href = "/auth/login";
        });
    },
    async Restore_this(id) {
      this.restore_offer = true;
      await axios
        .post(`/offers/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_offer = false;
          this.is_restored_offer = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
  },
};
</script>
